import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_121_add_parts_return: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Parts return",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "parts_return",
        TableName: "service_spare_part_return",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Parts return details",
            BindValue: "con_parts_return_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_return_no",
                label: "Return no#",
                placeholder: "This will be auto populate...",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "return_no",
                disabled: true,
                AutoPopulate: true,
                AutoPopulate_format: "PRN_[******]",
              },
              // Return date (required, DateTime)
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_returndate",
                label: "Return date",
                placeholder: "return_date",
                DefaultToday: true,
                required: true,
                Json_Attribute: "return_date",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Return date is required",
                  },
                ],
              },
              // Issue no (required, Search_Select)
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "issue_no",
                label: "Issue no",
                placeholder: "",
                required: true,
                lookupName: "issued_Spareparts",
                options: [],
                searchable: true,
                clearable: true,
                Json_Attribute: "issue_id",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Issue no is required",
                  },
                ],
              },
            ],
          },

          // Return no# (auto-generated, read-only)

          // Part details section with SubModule
          {
            componentType: ComponentType.SUB_MODULE,
            name: "sub_Checklist",
            label: "Part details",
            tableName: "service_spare_parts_return_details",
            lookupName: "issued_Spareparts_details",
            parentField: "issue_no",
            BindValue: "sub_checklist",
            childControls: [
              // Code (Select with issued_Spareparts_details lookup, Parent_Field: issue_no)
              {
                componentType: ComponentType.SELECT_DROPDOWN,
                name: "drp_code",
                label: "Code",
                placeholder: "",
                required: false,
                lookupName: "issued_Spareparts_details",
                parentField: "issue_no",
                options: [],
                Json_Attribute: "codeid",
                BindValue: "drp_code",
              },
              // Item name (TextView, read-only, BindParent from drp_code)
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_itemname",
                label: "Item name",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "item_name",
                disabled: true,
                BindParent: {
                  drp_code: "item_name",
                },
              },
              // Qty (Numeric, read-only, default 0)
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_qty",
                label: "Qty",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "qty",
                disabled: true,
              },
              // Return qty (Numeric, default 0, with validation)
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_return_qty",
                label: "Return qty",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "return_qty",
                validation: [
                  {
                    rule: ValidationRule.MAX_VALUE,
                    value: 0, // This will be validated dynamically: [txt_qty] >= [this]
                    message:
                      "Return quantity should not be greater than issued quantity",
                  },
                ],
              },
              // Rate (Numeric, read-only, default 0)
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_rate",
                label: "Rate",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "rate",
                disabled: true,
              },
              // Amount (Numeric, read-only, expression: txt_rate * txt_return_qty)
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_amount",
                label: "Amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "amount",
                disabled: true,
                ExpressionV2: "[txt_rate] * [txt_return_qty]",
              },
            ],
          },
        ],
      },
      // Submit button
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
